import { api } from "./client";

export const messagesApi = {
  inbox: async () => {
    const res = await api.get("/inbox");
    return res.data;
  },
  unreadCount: async () => {
    const res = await api.get("/inbox/unread-count");
    return res.data;
  },
  createInquiry: async ({ listingId, message }) => {
    const res = await api.post("/inquiries", { listing_id: listingId, message });
    return res.data;
  },
  thread: async (threadId) => {
    const res = await api.get(`/threads/${threadId}`);
    return res.data;
  },
  sendMessage: async (threadId, body) => {
    const res = await api.post(`/threads/${threadId}/messages`, { body });
    return res.data;
  },
  close: async (threadId) => {
    const res = await api.post(`/threads/${threadId}/close`, {});
    return res.data;
  },
  reopen: async (threadId) => {
    const res = await api.post(`/threads/${threadId}/reopen`, {});
    return res.data;
  },
  report: async (threadId, payload) => {
    const res = await api.post(`/threads/${threadId}/report`, payload);
    return res.data;
  },
  block: async (threadId) => {
    const res = await api.post(`/threads/${threadId}/block`, {});
    return res.data;
  },
};
